export default __webpack_public_path__ + "static/media/result-success.e3bfa71b.svg";